/**
 * Curated quotes for the Cortex loading screen.
 * Blends energy wisdom, data science, physics, technology, and engineering insights.
 */

export interface Quote {
  text: string;
  author: string;
  category?: string;
}

export const CORTEX_QUOTES: Quote[] = [
  {
    text: "What gets measured gets managed.",
    author: "Peter Drucker",
  },
  {
    text: "If you want to find the secrets of the universe, think in terms of energy, frequency and vibration.",
    author: "Nikola Tesla",
  },
  {
    text: "Without data, you're just another person with an opinion.",
    author: "W. Edwards Deming",
  },
  {
    text: "Energy cannot be created or destroyed; it can only be transformed.",
    author: "First Law of Thermodynamics",
  },
  {
    text: "The best way to predict the future is to invent it.",
    author: "Alan Kay",
  },
  {
    text: "Errors using inadequate data are much less than those using no data at all.",
    author: "Charles Babbage",
  },
  {
    text: "Efficiency is doing things right; effectiveness is doing the right things.",
    author: "Peter Drucker",
  },
  {
    text: "Information is the resolution of uncertainty.",
    author: "Claude Shannon",
  },
  {
    text: "Nature is written in mathematical language.",
    author: "Galileo Galilei",
  },
  {
    text: "Data is a precious thing and will last longer than the systems themselves.",
    author: "Tim Berners-Lee",
  },
  {
    text: "In God we trust. All others must bring data.",
    author: "W. Edwards Deming",
  },
  {
    text: "Nothing in life is to be feared, it is only to be understood. Now is the time to understand more.",
    author: "Marie Curie",
  },
  {
    text: "Simplicity is the ultimate sophistication.",
    author: "Leonardo da Vinci",
  },
  {
    text: "Optimization isn't just about saving energy — it's about maximizing industrial potential.",
    author: "Cortex Intelligence",
  },
  {
    text: "The science of today is the technology of tomorrow.",
    author: "Edward Teller",
  },
  {
    text: "When you can measure what you are speaking about and express it in numbers, you know something about it.",
    author: "Lord Kelvin",
  },
  {
    text: "High power factor and harmonic balance are the pillars of grid reliability.",
    author: "Power Systems Engineering",
  },
  {
    text: "Small daily improvements in power efficiency yield massive annual savings.",
    author: "Industrial Wisdom",
  },
  {
    text: "Everything should be made as simple as possible, but not simpler.",
    author: "Albert Einstein",
  },
  {
    text: "We can only see a short distance ahead, but we can see plenty there that needs to be done.",
    author: "Alan Turing",
  },
  {
    text: "Look deep into nature, and then you will understand everything better.",
    author: "Albert Einstein",
  },
  {
    text: "The goal is to turn data into information, and information into insight.",
    author: "Carly Fiorina",
  },
  {
    text: "Measure what is measurable, and make measurable what is not so.",
    author: "Galileo Galilei",
  },
  {
    text: "Intelligence is the ability to adapt to change.",
    author: "Stephen Hawking",
  },
  {
    text: "There is no substitute for hard work and precise data.",
    author: "Thomas Edison",
  },
  {
    text: "The finest systems operate silently in the background.",
    author: "System Design Principle",
  },
  {
    text: "Energy is the fundamental currency of modern civilization.",
    author: "Physics Principle",
  },
  {
    text: "Quality is not an act, it is a habit.",
    author: "Aristotle",
  },
  {
    text: "Simplicity is prerequisite for reliability.",
    author: "Edsger W. Dijkstra",
  },
  {
    text: "Where there is data, there is insight waiting to be discovered.",
    author: "Cortex Engineering",
  },
  {
    text: "Precision isn't just accuracy — it is consistency over time.",
    author: "Metrology Standard",
  },
  {
    text: "Continuous monitoring turns potential failures into predictable maintenance.",
    author: "Reliability Engineering",
  },
  {
    text: "The advance of technology is based on making it fit in so that you don't even notice it.",
    author: "Mark Weiser",
  },
  {
    text: "Truth is much more easily revealed through data than through dogma.",
    author: "Data Science Insight",
  },
  {
    text: "Real-time visibility turns uncertainty into control.",
    author: "Cortex Power Systems",
  },
];

export const LOADING_STATUS_STEPS = [
  "Connecting to Cortex Engine...",
  "Streaming telemetry from meter array...",
  "Calculating power factor & kVAh metrics...",
  "Synthesizing energy intelligence...",
  "Preparing interactive dashboard...",
];
